import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import useFadeIn from 'app/Components/Shared/UseFadeIn';
import ITSubImageBlockData from 'app/Models/Content/ITSubImageBlockData';
import ITSubImagesItemsBlockData from 'app/Models/Content/ITSubImagesItemsBlockData';
import {getTextWithHighlight} from 'app/utilities/highlightText';
import MarketingTextBlockData from 'Models/Content/MarketingTextBlockData';
import React from 'react';
import {getBackgroundImageProps} from 'app/utilities/ImageProps';

const ITSubImagesItemsBlock = ({data, context}: ComponentProps<ITSubImagesItemsBlockData>) => {
  const {fadeClass, ref} = useFadeIn();

  return (
    <div ref={ref} className={`ITSubImagesItemsBlock ${fadeClass}`}>
      {data.items.expandedValue.map((item: ITSubImageBlockData, i) => (
        <div className='ITSubImagesItemsBlock__item' key={i} {...getBackgroundImageProps(item.titleAsImage, context)}>
          <div className='ITSubImagesItemsBlock__item__title-and-subtitle'>
            {item.title.expandedValue.map(({text, highlightText}: MarketingTextBlockData, i) => (
              <h2 key={i}>{getTextWithHighlight({text: text.value, highlightText: highlightText.value})}</h2>
            ))}
            <div className='ITSubImagesItemsBlock__item__title-and-subtitle__subtitle'>{item.subtitle.value}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ITSubImagesItemsBlock;
